import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { PublicRoute, PrivateRoute } from "./config/index";
import Login from "../screens/Auth/Login";
import ErrorScreen from "../screens/Error/ErrorScreen";
import ResetPassword from "../screens/Auth/Reset";
import SuccessPage from "../screens/Auth/Success";
import HandlePassword from "../screens/Auth/HandlePassword";
import UpdatePassword from "../screens/Auth/UpdatePassword";
import SetPassword from "../screens/Auth/SetPassword";
import IncidentLayout from "../layouts/incidentLayout";
import Details from "../screens/Incidents/Forms/details";
import Factors from "../screens/Incidents/Forms/factors";
import Statements from "../screens/Incidents/Forms/statements";
import PatientDemographics from "../screens/Incidents/Forms/patient-demographics";
import Response from "../screens/Incidents/Forms/response";
import Conclusion from "../screens/Incidents/Forms/conclusion";
import TestForm from "../screens/Incidents/Forms/TestForm";
import Approval from "../screens/Incidents/approvals";
import Logs from "../screens/Incidents/logs";
import Dashboard from "../screens/User/dashboard";
import IncidentsByTrends from "../screens/User/analytics/report/IncidentsByTrends";
import IncidentsList from "../screens/User/IncidentsList";
import Report from "../screens/User/analytics/report/Report";
import Analytics from "../screens/User/analytics/Analytics";
import Users from "../screens/User/Users/users";
import CreateUser from "../screens/User/Users/createUser";
import UserManagement from "../screens/User/Users/UserManagement/UpdateUser/UserManagement";
import Help from "../screens/User/help/Help";
import Settings from "../screens/User/settings";
import QapiReport from "../Reports/qapi";
import AdminLayout from "../layouts/adminLayout/AdminLayout";
import Attachments from "../screens/Incidents/attachments";
import ErrorGenerator from "../components/Errors/ErrorGenerator";
import ErrorBoundaryRoute from "../components/Errors/ErrorBoundaryRoute";
import FallAnalysisReport from "../screens/User/analytics/fall-analysis/FallAnalysisReport";
import WoundAnalysisReport from "../screens/User/analytics/wound-analysis/WoundAnalysisReport";
import BehaviorAnalysisReport from "../screens/User/analytics/behaviorAnalysis/BehaviorAnalysisReport";
import CaregiverAuditReport from "../screens/User/analytics/caregiver-audit/CaregiverAuditReport";
import SupportRequestForm from "../screens/User/support/supportTicket";
import Builder from "../screens/User/analytics/report/Builder/Builder";

const AllRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundaryRoute>
        <PublicRoute>
          <Login />
        </PublicRoute>
      </ErrorBoundaryRoute>
    ),
    errorElement: <ErrorScreen />,
  },
  {
    path: "/reset",
    element: <ResetPassword />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/forgot",
    element: <HandlePassword />,
  },
  {
    path: "/newPassword",
    element: <HandlePassword />,
  },
  {
    path: "/update-password",
    element: <UpdatePassword />,
  },
  {
    /* Must stay public: PublicRoute would redirect a stale session past the emailed link. */
    path: "/set-password",
    element: <SetPassword />,
  },
  {
    path: "incidents",
    element: (
      <ErrorBoundaryRoute>
        <PrivateRoute>
          <IncidentLayout />
        </PrivateRoute>
      </ErrorBoundaryRoute>
    ),
    children: [
      {
        path: ":incidentIdOrNew/details",
        element: <Details />,
      },
      {
        path: ":incidentIdOrNew/factors",
        element: <Factors />,
      },
      {
        path: ":incidentIdOrNew/statements",
        element: <Statements />,
      },
      {
        path: ":incidentIdOrNew/patient-demographics",
        element: <PatientDemographics />,
      },
      {
        path: ":incidentIdOrNew/response",
        element: <Response />,
      },
      {
        path: ":incidentIdOrNew/conclusion",
        element: <Conclusion />,
      },
      {
        path: ":incidentIdOrNew/test",
        element: <TestForm />,
      },
      {
        path: ":incidentIdOrNew/approvals",
        element: <Approval />,
      },
      {
        path: ":incidentIdOrNew/attachments",
        element: <Attachments />,
      },
      {
        path: ":incidentIdOrNew/audit-logs",
        element: <Logs />,
      },
    ],
  },
  {
    path: "user",
    element: (
      <ErrorBoundaryRoute>
        <PrivateRoute>
          <AdminLayout />
        </PrivateRoute>
      </ErrorBoundaryRoute>
    ),
    children: [
      {
        path: "dashboard/*",
        element: <Dashboard />,
      },
      {
        path: "incidents-list/*",
        element: <IncidentsList />,
      },
      {
        path: "incidents-list-by-trends",
        element: <IncidentsByTrends />,
      },
      {
        path: "analytics/report",
        element: <Report />,
      },
      {
        path: "analytics/fall-analysis",
        element: <FallAnalysisReport />,
      },
      {
        path: "analytics/wound-analysis",
        element: <WoundAnalysisReport />,
      },
      {
        path: "analytics/behavior-analysis",
        element: <BehaviorAnalysisReport />,
      },
      {
        path: "analytics/caregiver-audit",
        element: <CaregiverAuditReport />,
      },
      {
        path: "analytics/builder",
        element: <Builder />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "users/create",
        element: <CreateUser />,
      },
      {
        path: "users/user-management/*",
        element: <UserManagement />,
      },
      {
        path: "help",
        element: <Help />,
      },
      {
        path: "support",
        element: <SupportRequestForm />,
      },
      {
        path: "settings/*",
        element: <Settings />,
      },
      {
        path: "error-generator",
        element: <ErrorGenerator shouldThrow={true} />,
      },
    ],
  },
  {
    path: "user/reports/:id",
    element: (
      <ErrorBoundaryRoute>
        <QapiReport />,
      </ErrorBoundaryRoute>
    ),
  },
]);

export default AllRoutes;
